import React, { Component } from "react";
import './App.css';
import { withRouter } from "react-router";
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ComingSoon from './components/ComingSoon/ComingSoon';


class App extends Component {
  
  constructor(props) {
    super(props);
    this.state = { 
      solidHeaderClass: 'solid-header',
      headerSolid: false
    };  
  }

  componentDidMount(){
    window.addEventListener('scroll', this.handleScroll, true);
    //Import Fonts
    // import('./font.js');
  }

  componentWillUnmount(){
    window.removeEventListener('scroll', this.handleScroll, true);
  }

  handleScroll = (e) => {
    let yPos;
    if ( typeof(e.target.scrollingElement ) !== 'undefined' && typeof(e.target.scrollingElement.scrollTop) !== 'undefined' ) {
      yPos = e.target.scrollingElement.scrollTop;
    } else if ( typeof(e.srcElement.scrollingElement) !== 'undefined' && typeof(e.srcElement.scrollingElement.scrollTop) !== 'undefined' ) {
      yPos = e.srcElement.scrollingElement.scrollTop;
    }
    
    if (yPos || yPos === 0) {
      if ( yPos >= 60 && !this.state.headerSolid ) {
        this.makeHeaderSolid();
      } else if ( yPos < 60 && this.state.headerSolid ) {
        this.makeHeaderTransparent();
      }
    }
  }

  makeHeaderSolid = () => {
    this.setState(prevState => ({
      headerSolid: true
    }));
  }

  makeHeaderTransparent = () => {
    this.setState(prevState => ({
      headerSolid: false
    }));
  }

  render() {
    let appClasses = 'App';
    if (this.state.headerSolid) appClasses += ' ' + this.state.solidHeaderClass;
    // Site is being rebuilt: serve the shell with an under construction banner on every route
    return (
      <div id="App" className={appClasses}>
        <Header showMenuToggle={false} />
        <div className="main">
          <ComingSoon />
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(App);
